"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Seo = exports.SeoDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var react_helmet_1 = require("react-helmet");
var lodash_1 = require("lodash");
var use_app_metadata_1 = require("../../hooks/use-app-metadata");
exports.SeoDefaultProps = {
  article: false,
  includeOpenGraph: false
};
// -------- Components -------->
// superfluous, but maintains consistent coding pattern :)
var My = {
  Helmet: react_helmet_1.Helmet
};
var Seo = function (_a) {
  var title = _a.title,
    description = _a.description,
    image = _a.image,
    pathname = _a.pathname,
    article = _a.article,
    openGraph = _a.openGraph,
    includeOpenGraph = _a.includeOpenGraph;
  var metadata = (0, use_app_metadata_1.useAppMetadata)();
  var useOpenGraph = includeOpenGraph || !!openGraph;
  var og = {
    title: (0, lodash_1.get)(openGraph, 'title', title || metadata.name),
    description: (0, lodash_1.get)(openGraph, 'description.plain', description || metadata.description),
    image: (0, lodash_1.get)(openGraph, 'image.url', metadata.image),
    url: (0, lodash_1.get)(openGraph, 'url', "".concat(metadata.url).concat(pathname || "/")),
    date: (0, lodash_1.get)(openGraph, 'date'),
    author: (0, lodash_1.get)(openGraph, 'author')
  };
  return React.createElement(My.Helmet, {
    title: og.title,
    titleTemplate: metadata.titleTemplate
  }, React.createElement("meta", {
    name: "description",
    content: og.description
  }), React.createElement("meta", {
    name: "image",
    content: og.image
  }), useOpenGraph && og.url && React.createElement("meta", {
    property: "og:url",
    content: og.url
  }), useOpenGraph && (article ? true : null) && React.createElement("meta", {
    property: "og:type",
    content: "article"
  }), useOpenGraph && og.title && React.createElement("meta", {
    property: "og:title",
    content: og.title
  }), useOpenGraph && og.description && React.createElement("meta", {
    property: "og:description",
    content: og.description
  }), useOpenGraph && og.image && React.createElement("meta", {
    property: "og:image",
    content: og.image
  }), React.createElement("meta", {
    name: "twitter:card",
    content: "summary_large_image"
  }), og.title && React.createElement("meta", {
    name: "twitter:title",
    content: og.title
  }), og.description && React.createElement("meta", {
    name: "twitter:description",
    content: og.description
  }), og.image && React.createElement("meta", {
    name: "twitter:image",
    content: og.image
  }));
};
exports.Seo = Seo;
exports.Seo.defaultProps = exports.SeoDefaultProps;